import React, { Component } from 'react';
import { Button } from 'antd';
import Icon from '@ant-design/icons';
import { withRouter, RouteComponentProps } from 'react-router';

import { ReactComponent as CrossSVG } from '../../../assets/sightx-icons/svg/x-close.svg';
import { ReactComponent as AlertSVG } from '../../../assets/sightx-icons/svg/sx-alert-circle.svg';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';

import styles from './videoBanner.module.scss';

interface IVideoBannerProps {
  onClose: () => void;
  accountId: string;
}

type IProps = IVideoBannerProps & RouteComponentProps;

class VideoBannerBase extends Component<IProps> {
  constructor(props: IProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  private handleClick() {
    this.props.history.push(`/accounts/${this.props.accountId}/video`);
  }

  render() {
    const { onClose } = this.props;

    if (!isFeatureEnabled(Features.VideoTracking)) {
      return null;
    }

    return (
      <div className={styles.videoBanner}>
        <div className={styles.content}>
          <div className={styles.iconContainer}>
            <Icon component={AlertSVG} className={styles.icon} />
          </div>
          <div className={styles.text}>
            <span className={styles.bold}>Video set up</span>
            <span>Go to the Video tab to configure usage tracking for this account.</span>
          </div>
        </div>
        <div className={styles.buttons}>
          <Button type="primary" onClick={this.handleClick}>Go to video</Button>
          <Icon component={CrossSVG} className={styles.closeButton} onClick={onClose} />
        </div>
      </div>
    );
  }
}

export const VideoBanner = withRouter(VideoBannerBase);
